import React from "react";
import { Star, Quote } from "lucide-react";
import { testimonials } from "../mock";
import Reveal from "./Reveal";

const initials = (name) =>
  name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

const TestimonialCard = ({ t, delay }) => (
  <Reveal delay={delay}>
    <div className="relative bg-white rounded-2xl p-7 shadow-lg shadow-black/10 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 h-full flex flex-col">
      <Quote className="absolute top-6 right-6 h-9 w-9 text-[#35c6f4]/20" />

      <div className="flex items-center gap-1 mb-4">
        {Array.from({ length: t.rating }).map((_, i) => (
          <Star key={i} className="h-5 w-5 fill-[#f5b642] text-[#f5b642]" />
        ))}
      </div>

      <p className="text-slate-700 leading-relaxed flex-1">"{t.text}"</p>

      <div className="flex items-center gap-4 mt-6 pt-5 border-t border-slate-100">
        <span className="grid place-items-center h-12 w-12 rounded-full bg-[#071a2f] text-[#35c6f4] font-cond font-semibold text-lg shrink-0">
          {initials(t.name)}
        </span>
        <div>
          <p className="font-cond font-semibold text-[#071a2f] leading-tight">
            {t.name}
          </p>
          <p className="text-sm text-slate-500">
            {t.role} &middot; {t.location}
          </p>
        </div>
      </div>
    </div>
  </Reveal>
);

const Testimonials = () => {
  return (
    <section id="reviews" className="bg-gradient-to-b from-white via-[#e6faff] to-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <Reveal>
          <div className="text-center mb-16">
            <p className="font-cond uppercase tracking-[0.3em] text-[#0a6bb0] text-sm mb-3">
              Reviews
            </p>
            <h2 className="font-display text-4xl md:text-6xl text-[#071a2f]">
              WHAT PINELLAS COUNTY{" "}
              <span className="text-[#0aa5e0]">SAYS</span>
            </h2>
            <div className="h-1.5 w-24 bg-gradient-to-r from-[#0aa5e0] to-[#4fd4ff] rounded-full mx-auto mt-5 glow-cyan-sm" />
            <p className="text-slate-600 mt-6 max-w-xl mx-auto">
              Homeowners and property managers across the county trust the TNT
              Legacy team to keep their properties looking their best.
            </p>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((t, i) => (
            <TestimonialCard key={t.name} t={t} delay={(i % 3) * 120} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
